module.exports = __webpack_public_path__ + "img/chengxiaoyu.a884c6c4.jpg";